import { FC } from 'react';
import { Card, Skeleton } from '@mofid-securities/uikit';

export const DescriptionSkeleton: FC = () => {
  return (
    <Card
      className="border-1 border border-gray-solid-primary-enabled"
      padding={16}
      radius="md"
    >
      <Skeleton height={22} mb={8} width={118} />
      <Skeleton height={90} width={288} />
    </Card>
  );
};
